import React from "react";
import { Box, Typography, Container } from "@mui/material";
import { useSelector } from "react-redux";
import pattern from "../../../assets/pattern.png";
import logoBrown from "../../../assets/logoBrown.png";
import { RootState } from "../../../store/Index";
import "../../../print.css";

const MemoryBookDeliveryNote: React.FC = () => {
  const reduxTheme = useSelector((state: RootState) => state.theme);

  return (
    <Box sx={{ p: 2 }}>
      <Box
        className="print-container"
        sx={{
          backgroundSize: "20px 20px",
          backgroundPosition: "0 0, 0 10px, 10px -10px, -10px 0px",
          minHeight: "calc(100vh - 80px)",
          color: reduxTheme.primary_colors?.[400] || "#724E41",
          padding: "20px",
          backgroundImage: `url(${pattern})`,
        }}
      >
        <Box
          sx={{
            bgcolor: reduxTheme.primary_colors?.[900] || "#ffffff",
            minHeight: "100vh",
            p: 0,
            "@media print": {
              minHeight: "auto",
              height: "auto",
              overflow: "visible",
              maxWidth: "900px",
              mx: "auto",
              my: 4,
              px: 4,
              py: 4,
              boxSizing: "border-box",
              boxShadow: "0 0 0 1px #ccc",
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-end",
              height: "auto",
              width: "100%",
              mt: 2,
            }}
          >
            <img
              alt="muzukuru"
              width="240px"
              height="80px"
              src={logoBrown || "/placeholder.svg"}
              style={{ objectFit: "contain" }}
            />
          </Box>

          {/* Header Bar */}
          <Box
            sx={{
              bgcolor: reduxTheme.primary_colors?.[400] || "#7B4B47",
              color: reduxTheme.primary_colors?.[900] || "#ffffff",
              p: 0,
              backgroundImage: "url(/static/images/pattern.png)",
              backgroundSize: "20px 20px",
              borderBottom: "3px solid black",
              position: "relative",
              height: "20px",
            }}
          />
          {/* Title */}
          <Typography
            variant="h3"
            align="center"
            sx={{
              fontWeight: 600,
              mb: 3,
              mt: 3,
              letterSpacing: 2,
            }}
          >
            MEMORY BOOK DELIVERY NOTE
          </Typography>

          <Container maxWidth="md">
            {/* Receiver&apos;s Information */}
            <Box sx={{ mt: 2, px: 2, "@media print": { px: 0 } }}>
              <Typography sx={{ fontWeight: "bold", mb: 0.5, mt: 1 }}>
                RECEIVER&apos;S INFORMATION
              </Typography>
              <Box
                sx={{
                  borderBottom: "2px solid #222",
                  mb: 3,
                  "@media print": { mb: 3 },
                }}
              />
              {["NAME", "PHONE", "EMAIL", "SIGNATURE"].map((label) => (
                <Box
                  key={label}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mb: 3,
                    ml: 2,
                  }}
                >
                  <Typography
                    sx={{
                      minWidth: 120,
                      fontSize: 14,
                      color: reduxTheme.primary_colors?.[700] || "#000000",
                    }}
                  >
                    {label} :
                  </Typography>
                  <Box
                    sx={{
                      borderBottom: "1px solid #888",
                      flex: 1,
                      ml: 2,
                      height: 26,
                    }}
                  />
                </Box>
              ))}
            </Box>

            {/* Delivery Information */}
            <Box sx={{ mt: 4, px: 2, "@media print": { px: 0 } }}>
              <Typography sx={{ fontWeight: "bold", mb: 0.5 }}>
                DELIVERY INFORMATION
              </Typography>
              <Box
                sx={{
                  borderBottom: "2px solid #222",
                  mb: 3,
                  "@media print": { mb: 3 },
                }}
              />
              {["DELIVERED BY", "DATE", "MEMORY BOOK NAME", "SIGNATURE"].map(
                (label) => (
                  <Box
                    key={label}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      mb: 3,
                      ml: 2,
                    }}
                  >
                    <Typography
                      sx={{
                        minWidth: 140,
                        fontSize: 14,
                        color: reduxTheme.primary_colors?.[700] || "#000000",
                      }}
                    >
                      {label} :
                    </Typography>
                    <Box
                      sx={{
                        borderBottom: "1px solid #888",
                        flex: 1,
                        ml: 2,
                        height: 24,
                      }}
                    />
                  </Box>
                )
              )}
            </Box>
          </Container>

          {/* Bottom Logo and Contact */}
          <Box sx={{ mt: 6, mb: 1, textAlign: "center" }}>
            <img
              src={logoBrown}
              alt="Muzukuru"
              style={{ width: 120, margin: "0 auto" }}
            />
            <Box sx={{ borderBottom: "1px ", mb: 1 }} />
            <Typography
              sx={{
                fontSize: 14,
                mt: 1,
                color: reduxTheme.primary_colors?.[700] || "#000000",
              }}
            >
              Phone: +263 776 402 402 | tawanda@muzukuru.co.zw |
              www.muzukuru.co.zw
            </Typography>
            <Typography
              sx={{
                fontSize: 14,
                color: reduxTheme.primary_colors?.[700] || "#000000",
              }}
            >
              46 B Mount Pleasant Drive, Mount Pleasant, Harare, Zimbabwe
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default MemoryBookDeliveryNote;
